import { Link } from 'react-router-dom';
import type { FC } from 'react';

const features = [
  {
    icon: 'ri-4k-fill',
    title: '高清画质',
    desc: '支持4K超清画质，多种清晰度自由切换，满足不同网络环境下的观影需求。',
  },
  {
    icon: 'ri-speed-up-fill',
    title: '极速加载',
    desc: '全球CDN加速节点覆盖，智能调度最优线路，确保视频秒开不卡顿。',
  },
  {
    icon: 'ri-shield-check-fill',
    title: '免费观看',
    desc: '所有视频内容完全免费，无需会员、无需付费，打开即看。',
  },
  {
    icon: 'ri-smartphone-fill',
    title: '多端适配',
    desc: '手机、平板、电脑全终端适配，随时随地畅享精彩影视内容。',
  },
  {
    icon: 'ri-calendar-check-fill',
    title: '实时更新',
    desc: '热门剧集同步更新，第一时间追更最新内容，再也不用等资源。',
  },
  {
    icon: 'ri-global-fill',
    title: '海量资源',
    desc: '涵盖电视剧、电影、动漫、综艺、纪录片等全品类，10万+视频资源。',
  },
];

const FeatureSection: FC = () => {
  const schemaJson = {
    '@context': 'https://schema.org',
    '@type': 'ItemList',
    itemListElement: features.map((feature, index) => ({
      '@type': 'ListItem' as const,
      position: index + 1,
      item: {
        '@type': 'Thing' as const,
        name: feature.title,
        description: feature.desc,
      },
    })),
  };

  return (
    <>
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(schemaJson) }}
      />
      <section className="py-14 md:py-20">
        <div className="max-w-[1400px] mx-auto px-4 md:px-6">
          <div className="text-center mb-12">
            <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-50 mb-4">
              为什么选择 <span className="text-primary-400">棒棒TV</span>
            </h2>
            <p className="text-foreground-400 max-w-2xl mx-auto">
              我们致力于为用户提供最优质的在线视频观看体验
            </p>
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
            {features.map((feature, index) => (
              <div
                key={index}
                className="group bg-background-100 border border-background-300/30 rounded-xl p-6 hover:border-primary-500/30 transition-all duration-300 cursor-default"
              >
                <div className="w-12 h-12 flex items-center justify-center rounded-xl bg-primary-500/10 text-primary-400 mb-4 group-hover:bg-primary-500/20 transition-colors duration-300">
                  <i className={`${feature.icon} text-xl`}></i>
                </div>
                <h3 className="text-base font-semibold text-foreground-100 mb-2">
                  {feature.title}
                </h3>
                <p className="text-sm text-foreground-400 leading-relaxed">
                  {feature.desc}
                </p>
              </div>
            ))}
          </div>

          {/* CTA */}
          <div className="mt-14 text-center">
            <Link
              to="/about"
              className="whitespace-nowrap inline-flex items-center gap-2 px-6 py-3 text-sm font-medium text-foreground-200 hover:text-primary-400 border border-background-300/40 hover:border-primary-500/40 rounded-full transition-all duration-300 cursor-pointer"
            >
              了解更多关于我们
              <i className="ri-arrow-right-line"></i>
            </Link>
          </div>
        </div>
      </section>
    </>
  );
};

export default FeatureSection;